module.exports = __webpack_public_path__ + "static/media/ricardo-gomez-angel-2oIgnII4f-0-unsplash -desk-1920.08729ffb.jpg";